import gql from 'graphql-tag';
import * as Firebase from 'firebase';

const GQL = gql`
  query KmzParse($url: String!) {
    kmzParse(url: $url) {
      name
      area
      geometry {
        type
        coordinates
      }
    }
  }
`;

export default async function(client: any, url: string) {
  const auth = Firebase.auth();
  const token = auth && auth.currentUser ? await auth.currentUser.getIdToken() : '';
  const { data } = await client.query({
    query: GQL,
    variables: { url },
    context: {
      headers: {
        authorization: token
      }
    }
  });
  return data.kmzParse;
}


// WEBPACK FOOTER //
// ./src/services/kmzParse.ts